export default "__VITE_ASSET__DRKal8he__"